import React from 'react';

import { withRef, withVariants } from '@udecode/cn';
import { cva } from 'class-variance-authority';

import { PlateElement } from './plate-element';

const headingVariants = cva('relative mb-1', {
  variants: {
    variant: {
      h1: 'mt-[1em] pb-1 font-heading text-xl font-medium',
      h2: 'mt-[0.75em] pb-px font-heading text-lg font-medium tracking-tight',
      h3: 'mt-[0.75em] pb-px font-heading text-base font-medium tracking-tight',
      h4: 'mt-[0.75em] font-heading text-lg font-semibold tracking-tight',
      h5: 'mt-[0.75em] text-lg font-medium tracking-tight',
      h6: 'mt-[0.75em] text-base font-medium tracking-tight',
    },
  },
});

const HeadingElementVariants = withVariants(PlateElement, headingVariants, [
  'variant',
]);

export const HeadingElement = withRef<typeof HeadingElementVariants>(
  ({ children, variant = 'h1', ...props }, ref) => {
    return (
      <HeadingElementVariants
        ref={ref}
        as={variant!}
        variant={variant}
        {...props}
      >
        {children}
      </HeadingElementVariants>
    );
  }
);
